import { ReactElement, useCallback } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { useNavigate } from 'react-router'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useIntl } from 'react-intl'
import UserForm from '../../forms/user-form'
import { useCreateUser } from '../../hooks/use-create-user'

const UserAddScreen = (): ReactElement => {
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  const registerUser = useCreateUser()

  const onSubmit = useCallback(async (data) => {
    const result = await registerUser(data)
    if (result) {
      navigate('/admin/users')
    }
  }, [])

  return (
    <Flexbox isCol flex={1}>
      <ScreenTitle
        title={formatMessage({
          id: 'TITLE_ADD_USER',
          defaultMessage: 'Add user',
        })}
      />
      <UserForm onSubmit={onSubmit} buttonTitle="Register" />
    </Flexbox>
  )
}

export default UserAddScreen